import { Method } from '@ori-events/add-to-basket';
export var getAddToBasketMethod = function getAddToBasketMethod(hasEnoughPoints) {
  return hasEnoughPoints ? Method.BUY_FOR_POINTS : undefined;
};
//# sourceMappingURL=getAddToBasketMethod.js.map